// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  margin-bottom: 0 !important;
  position: fixed;
  z-index: 10;
  background-color: white;
  width: 100%;
}
nav .container-fluid .navbar-header {
  float: right;
}
nav .container-fluid .navbar-header button {
  right: 0;
}
nav .container-fluid .navbar-header .navbar-brand {
  margin-left: 15px;
}

@media (max-width: 768px) {
  nav .container-fluid .navbar-header .navbar-brand {
    position: absolute;
    left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/navbar/navbar.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/layouts/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;ACCF;ADCI;EACE,YAAA;ACCN;ADAM;EACE,QAAA;ACER;ADAM;EACE,iBAAA;ACER;;ADIA;EAIQ;IACE,kBAAA;IACA,OAAA;ECJR;AACF","sourcesContent":["nav {\r\n  margin-bottom: 0 !important;\r\n  position: fixed;\r\n  z-index: 10;\r\n  background-color: white;\r\n  width: 100%;\r\n  .container-fluid {\r\n    .navbar-header {\r\n      float: right;\r\n      button {\r\n        right: 0;\r\n      }\r\n      .navbar-brand {\r\n        margin-left: 15px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  nav {\r\n    .container-fluid {\r\n      .navbar-header {\r\n        .navbar-brand {\r\n          position: absolute;\r\n          left: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","nav {\n  margin-bottom: 0 !important;\n  position: fixed;\n  z-index: 10;\n  background-color: white;\n  width: 100%;\n}\nnav .container-fluid .navbar-header {\n  float: right;\n}\nnav .container-fluid .navbar-header button {\n  right: 0;\n}\nnav .container-fluid .navbar-header .navbar-brand {\n  margin-left: 15px;\n}\n\n@media (max-width: 768px) {\n  nav .container-fluid .navbar-header .navbar-brand {\n    position: absolute;\n    left: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
